var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SelectById',{staticClass:"mb-2"}),_c('SelectByBiz',{staticClass:"mb-3"}),_c('Orders')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }